import React from 'react'
import Modal from 'react-modal'
import { Button } from '@mobiscroll/react'

const modalSize = {
  sm: 'col-2',
  md: 'col-4',
  lg: 'col-6',
  xl: 'col-8'
}
const modalVariant = {
  info: 'mdl-bg-light-blue',
  success: 'mdl-bg-green',
  warning: 'mdl-bg-yellow',
  error: 'mdl-bg-red'
}

interface IActionBtnProps {
  cancelLabel?: string
  okLabel?: string
  okBtnOnly?: boolean
  onCancel?: () => void
  onConfirm?: () => void
  variant: 'info' | 'success' | 'warning' | 'error'
}
const ActionBtn = ({ cancelLabel, okLabel, okBtnOnly, onCancel, onConfirm, variant }: IActionBtnProps) => {
  return (
    <React.Fragment>
      <div className='mbsc-button-group mdl-actions flex justify-center pt1'>
        <Button className={`mdl-actions-btn mdl-ok-btn ${modalVariant[variant]}`} onClick={onConfirm}>
          {okLabel}
        </Button>
        {!okBtnOnly && (
          <Button className='mdl-actions-btn mdl-cancel-btn' onClick={onCancel} variant='flat'>
            {cancelLabel}
          </Button>
        )}
      </div>
    </React.Fragment>
  )
}

interface IProps {
  callToActions?: boolean
  cancelLabel?: string
  children?: JSX.Element
  okLabel?: string
  isOpen: boolean
  message?: string
  onCancel?: () => void
  onConfirm?: () => void
  okBtnOnly?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  title: string
  variant?: 'info' | 'success' | 'warning' | 'error'
}
const ModalWindow = ({
  callToActions = true,
  cancelLabel = 'Cancel',
  children,
  okLabel = 'Ok',
  isOpen,
  message = '',
  onCancel,
  onConfirm,
  okBtnOnly = false,
  size = 'md',
  title,
  variant = 'info'
}: IProps) => {
  return (
    <React.Fragment>
      <Modal ariaHideApp={false} className='Modal' isOpen={isOpen}>
        <div className='overlay bg-light-grey' />
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className={`b-rad-5 bg-white mdl-container ${modalSize[size]}`}>
            <div className={`mdl-header ${modalVariant[variant]} p2`}>
              <span className='ModalAddTitle weight-300 font-white h3'>{title}</span>
            </div>
            <div className='mdl-body p2'>
              {message && (
                <div className='py2'>
                  <span>{message}</span>
                </div>
              )}
              {children && children}
              {callToActions && (
                <ActionBtn
                  cancelLabel={cancelLabel}
                  okLabel={okLabel}
                  onCancel={onCancel}
                  onConfirm={onConfirm}
                  okBtnOnly={okBtnOnly}
                  variant={variant}
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default ModalWindow



// WEBPACK FOOTER //
// ./src/components/ui/ModalWindow.tsx